/* eslint-disable no-unused-vars */
import Framework, { shapes } from '@greenville/framework';
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  Box,
  makeStyles
} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
// import { ChatComponent } from '@vega/aitutor';
import axios from 'axios';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as constants from '../../../common/constants';
import env from '../../../common/env';
import utils from '../../../common/utils';
import chapterList from '../data/chapterList.json';
import GetPiTokenModel from '../models/GetPiTokenModel';

const useStyles = makeStyles((theme) => ({
  '@global': {
    // '#bot_container_id': {
    //   height: '97% !important'
    // },
    // '@supports selector(:has(*))': {
    //   'div:has(> #bot_container_id)': {
    //     height: 'auto !important',
    //     maxHeight: 'none !important'
    //   }
    // }
  },
  heading: {
    position: 'absolute',
    paddingTop: '1.1rem',
    textAlign: 'center',
    width: '50%',
    fontSize: '18px',
    fontWeight: '600'
  },
  contentWrapper: {
    position: 'relative',
    width: '100%',
    margin: '4rem auto',
    marginBottom: 'unset',
    height: 'calc(100vh - 70px)'
  },
  metaRoot: {
    '& .MuiTableCell-root': {
      padding: '0.55rem',
      textAlign: 'left'
    }
  },
  tableText: {
    textAlign: 'center',
    color: '#6a7070',
    fontSize: 14
  },
  leftTableContainer: {
    position: 'absolute',
    top: '60px',
    left: '32px',
    width: 'calc(50vw - 40px)',
    height: 'calc(100vh - 165px)',
    overflowY: 'auto',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    backgroundColor: 'white',
    zIndex: 500
  },
  copyUrlBox: {
    position: 'absolute',
    right: '8px',
    top: '71%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid #005d83',
    outline: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 93, 131, 0.08)'
    }
  }
}));

const configTypeMappings = {
  tenantId: 'Tenant Id',
  tenantKey: 'Tenant Key',
  tenantName: 'Tenant Name',
  courseId: 'Course Id',
  pageId: 'Page Id',
  userId: 'User Id',
  message: 'Message',
  tutorName: 'Tutor Name',
  botName: 'Bot Name',
  berlinEnv: 'Environment',
  expandMode: 'Expand Mode',
  productModel: 'Product Model',
  enableProblemSolveFeature: 'Problem Solve Feature',
  showRecommendedPrompts: 'Recommended Prompts',
  AIEnableHigherOrderSuggestion: 'Higher Order Suggestion',
  AIEnableNewValidateAnswer: 'New Validate Answer',
  AIEnableQuizRandomization: 'Quiz Randomization',
  AIEnableAIShowChannelVideos: 'Channel Videos',
  AIEnableAgentic: 'Agentic',
  enableExplainQuizOptions: 'Explain Quiz Options',
  graphName: 'Graph Name',
  graphId: 'Graph Id',
  channelId: 'Channel Id',
  version: 'Version',
  // Show/Hide Features
  showSummary: 'Show Summary',
  showPractice: 'Show Practice',
  showExplain: 'Show Explain',
  // Hidden Canned Messages Configuration
  isWelcomeMessageFromTestBed: 'Welcome Message From Test Bed',
  welcome: 'Welcome Message',
  welcomeBack: 'Welcome Back Message',
  bookTitle: 'Book Title',
  bookTitlePreText: 'Book Title Pre Text',
  bookTitleSubText: 'Book Title Sub Text',
  recommendationsHeading: 'Recommendations Heading',
  ctaButtonHeadingWithRecommendationPills: 'CTA Button Heading With Pills',
  ctaButtonHeadingWithOutRecommendationPills: 'CTA Button Heading Without Pills',
  newTopic: 'New Topic',
  newTopicSubMessage: 'New Topic Sub Message',
  autoOpenHeadingMessage: 'Auto Open Heading Message',
  autoOpenWelcomeMessage: 'Auto Open Welcome Message',
  ctaButtonHeadingQuizStopMode: 'CTA Button Heading Quiz Stop Mode'
};

const DynamicAIStudyTestComponent = () => {
  const classes = useStyles();
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [userToken, setUserToken] = useState('');
  const [tokenExpireTime, setTokenExpireTime] = useState(null);
  const [tokenValue, setTokenValue] = useState('');
  const [decodedData, setDecodedData] = useState(null);
  const [agenticConfig, setAgenticConfig] = useState({});
  const [customConfig, setCustomConfig] = useState({});
  const [users, setUsers] = useState({});

  const getPiTokenApiCall = async () => {
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.get(
      `${env.EVERGREEN_API_BASE_URL}${constants.GET_PI_TOKEN_URL}?prod=${
        decodedData.berlinEnv === 'prod' || decodedData.berlinEnv === 'ppe'
      }`,
      {
        headers
      }
    );
    if (response && response.data && response.data.data) {
      const { token, expiresIn } = response.data.data;
      setUserToken(token);
      setTokenExpireTime(expiresIn);
    }
  };

  useEffect(() => {
    const token = utils.getToken();
    setTokenValue(token);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(tokenValue)) {
      setTimeout(() => {
        setIsPageLoaded(true);
      }, 500);
      getPiTokenApiCall();
    }
  }, [tokenValue]);
  /* eslint-disable */

  useEffect(() => {
    if (!tokenExpireTime) return;
    const timeLeft = tokenExpireTime - Date.now() - 59000;
    const timeOutId = setTimeout(() => {
      getPiTokenApiCall();
    }, timeLeft);
    return () => clearTimeout(timeOutId);
  }, [tokenExpireTime]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encodedData = searchParams.get('configs');

    if (encodedData) {
      const decodedString = atob(encodedData);
      const decodedJsonString = decodeURIComponent(decodedString);
      const parsedData = JSON.parse(decodedJsonString);
      setProperties(parsedData);
      setDecodedData(parsedData);
    }
  }, [location.search]);

  const getAuthToken = (callback) => {
    const tokenConfig = {
      id: 'token',
      token: userToken
    };
    return new Promise((resolve) => {
      resolve(callback(tokenConfig.token));
    });
  };

  const handleChatbotOpened = (event) => {
    console.log('handleChatbotOpened callback', event);
  };

  const handleCopyURL = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        type: 'success',
        message: 'URL copied to clipboard successfully!'
      });
    } catch (err) {
      // Fallback for browsers that don't support clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = window.location.href;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        type: 'success',
        message: 'URL copied to clipboard successfully!'
      });
    }
  };

  const setProperties = (decodedData) => {
    const newAgenticConfig = { graphId: decodedData.graphId, graphVersion: decodedData.version };

    const users = {
      username: 'Vignesh Selvam',
      initials: 'VS',
      token: userToken,
      userId: decodedData.userId,
      isFirstTimeAITutorUser: false
    };

    const customConfig = {
      showActionIcons: {
        copy: true, // Feature defaults - Summary, practice & explain
        saveAsNote: decodedData.tenantName === constants.PVS ? false : true, // Feature - Summary & explain
        saveAsFlashcard: decodedData.tenantName === constants.PVS ? false : true // Feature - Summary & practice
      },
      summaryOptions: [
        {
          text: 'Current section',
          value: constants.CURRENT_SECTION
        },
        {
          text: 'Whole chapter',
          value: constants.CURRENT_CHAPTER
        },
        {
          text: 'Unit',
          value: 'unit'
        }
      ],
      quizOptions: [
        {
          text: 'Current section',
          value: constants.CURRENT_SECTION
        },
        {
          text: 'Whole chapter',
          value: constants.CURRENT_CHAPTER
        },
        {
          text: 'Unit',
          value: 'unit'
        }
      ],
      // floatingIcon: {
      //   toolTipName: 'Ask me about anything in your eTextbook',
      //   toolTipPlacement: 'left-center'
      // },
      // contentDetails: {
      //   chapterName: 'Chapter 10: Photosynthesis',
      //   sectionName: 'Concept 10.4: The Calvin cycle uses the chemical energy of ATP and NADPH to reduce CO2 to sugar'
      // },
      // headTag: {
      //   show: true, // true is default
      //   text: 'Beta'
      // },
      flags: {
        isWelcomeMessageFromTestBed: decodedData.isWelcomeMessageFromTestBed
      },
      cannedMessages: {
        appHeading: decodedData.botName,

        // appFooter:
        //   'PVS-AH Please don’t share personal data, and keep in mind that AI can be inaccurate. For more info, see our',
        // appFooterFAQLink: 'PVS-AH FAQs',
        // bookTitlePreText: "PVS-AH I'm here to help with anything related to ",
        // bookTitleSubText: '. PVS-AH Make a request below or choose from these options',
        // welcome: decodedData.message
        welcomeBack: decodedData.message
        // autoOpenHeadingMessage: 'PVS-AH Hi there! What can I help you with today?',
        // autoOpenWelcomeMessage: 'PVS-AH You can also try one of these common requests:',
        // newTopic: 'PVS-AH New topic it is!',
        // newTopicSubMessage: 'PVS-AH What can I help you with next?',
        // recommendationsHeading: 'PVS-AH Do you want me to explain a key topic from this page?',
        // ctaButtonHeadingWithOutRecommendationPills: 'PVS-AH Try one of these common requests:',
        // ctaButtonHeadingWithRecommendationPills: 'PVS-AH Or try one of these common requests:',
        // ctaButtonHeadingQuizStopMode: 'PVS-AH What can I help with next?',
        // summarizeOptionsHeading: 'PVS-AH Sure. What should I summarize?',
        // practiceOptionsHeading: 'PVS-AH Sure. Where should I pull those questions from?',
        // practiceOptionsTypeHeading: 'PVS-AH What kind of questions are you looking for?',
        // explainHeading: 'PVS-AH What topic or term from your eTextbook would you like explained?',
        // summaryButtonUserMessage: 'PVS-AH Can you summarize something for me?',
        // practiceButtonUserMessage: 'PVS-AH Can you generate some practice questions?',
        // explainButtonUserMessage: 'PVS-AH I need something explained'
      },
      cannedMessageVisibility: {
        bookTitle: decodedData.bookTitle,
        bookTitlePreText: decodedData.bookTitlePreText,
        bookTitleSubText: decodedData.bookTitleSubText,
        recommendationsHeading: decodedData.recommendationsHeading,
        ctaButtonHeadingWithRecommendationPills: decodedData.ctaButtonHeadingWithRecommendationPills,
        ctaButtonHeadingWithOutRecommendationPills: decodedData.ctaButtonHeadingWithOutRecommendationPills,
        newTopic: decodedData.newTopic
      }
    };

    setUsers(users);
    setAgenticConfig(newAgenticConfig);
    setCustomConfig(customConfig);
  };

  if (userToken === '') return null; // Render the ChatComponent only when userToken is available

  return (
    <div className={classes.contentWrapper}>
      <div className={classes.heading}>
        {constants.WELCOME_TO_TESTBED}
        <Tooltip title="Copy URL">
          <Box display="flex" alignItems="center" onClick={handleCopyURL} className={classes.copyUrlBox}>
            <LinkIcon style={{ color: '#005d83', fontSize: '18px' }} />
            <Typography variant="caption" style={{ marginLeft: '4px', color: '#005d83' }}>
              Share Graph
            </Typography>
          </Box>
        </Tooltip>
      </div>
      {decodedData && (
        <TableContainer className={classes.leftTableContainer}>
          <Table className={classes.metaRoot} stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="h5">{constants.CONFIGS}</Typography>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(decodedData).map(([key, value]) => {
                const displayName = configTypeMappings[key] || key;
                return (
                  <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell className={classes.tableText} fontWeight="bold" component="div">
                      {displayName}
                    </TableCell>
                    <TableCell className={classes.tableText} align="left">
                      {typeof value === 'boolean'
                        ? value.toString()
                        : typeof value === 'object'
                        ? JSON.stringify(value, null, 2)
                        : value}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {/* <ChatComponent
        customConfig={customConfig}
        isPageLoaded={isPageLoaded} // Required
        env={decodedData.berlinEnv} // {env.ENVIRONMENT} // Required
        users={users} // Required
        channelsVideoEsScore="10"
        theme="default" // Required
        masterTheme="plus" // Required
        locale="en-us" // Optional
        context={{
          bookTitle: 'Campbell Biology, 12e', // Required
          productModel: decodedData.productModel, // 'EXTERNAL_PVS' Required
          indexId: decodedData.courseId, // '0fc5534dbbeaad9b8dbdbdaa9ff4a74f',
          printPageNumber: '5', // Optional
          pageId: decodedData.pageId, // 'f92ced50-31ca-11ee-85d8-c7c9b8fd0d09',
          bookID: decodedData.courseId, // 'BRNT-XUF8BS197', // Required
          isPpmTextExtracted: false, // Optional
          secondaryBookId: 'd9096892-1923-4685-ab27-b6c32dd9455d', // Required
          chapterList, // Required
          chapterId: 'cfc05d6e0-31ca-11ee-8eb0-d709f5427093', // Required
          chapterTitle: 'Chapter 4: Carbon and the Molecular Diversity of Life', // Required
          chapterNumber: 19, // Required
          flashCardTenantObj: {
            tenantId: decodedData.tenantId,
            tenantKey: decodedData.tenantKey
          },
          berlinTenantObject: {
            tenantId: decodedData.tenantId,
            tenantKey: decodedData.tenantKey
          }
        }} // Required
        getAuthToken={getAuthToken} // Required
        headers={{
          userId: users?.userId
        }}
        handleChatbotOpened={handleChatbotOpened}
        openAIStudy={open} // Required
        showAIStudyIcon
        showUserHistory
        expandMode={decodedData.expandMode}
        toggleAIStudy={() => setOpen(!open)}
        enableProblemSolveFeature={decodedData.enableProblemSolveFeature}
        showRecommendedPrompts={decodedData.showRecommendedPrompts}
        AIEnableHigherOrderSuggestion={decodedData.AIEnableHigherOrderSuggestion}
        AIEnableNewValidateAnswer={decodedData.AIEnableNewValidateAnswer}
        AIEnableQuizRandomization={decodedData.AIEnableQuizRandomization}
        enableExplainQuizOptions={decodedData.enableExplainQuizOptions}
        channelId={decodedData.channelId.toLowerCase()}
        showAIChannelVideos={decodedData.AIEnableAIShowChannelVideos}
        isChannelsSubscriber={false} // Send this true if user has channels subscription
        isBundleSubscriber // Send this true if user has bundle subscription
        showOptoutLink={false} // {(isChannelsSubscriber || isBundleSubscriber) ? false : preferences.showChannelsOptOutLink}
        updateChannelsOptOut={() => {}} // {handleChannelVideoCallbackOptOut}
        showOptInLink={false} // {(isChannelsSubscriber || isBundleSubscriber) ? false : preferences.showChannelsOptInLink}
        showSummary={decodedData.showSummary}
        showPractice={decodedData.showPractice}
        showExplain={decodedData.showExplain}
        updateChannelsOptIn={() => {}} // {handleChannelVideoCallbackOptIn}
        enableAgenticAI={decodedData.AIEnableAgentic}
        agenticGraphConfig={agenticConfig}
      /> */}
    </div>
  );
};

DynamicAIStudyTestComponent.propTypes = {
  getPiToken: shapes.modelOf(GetPiTokenModel).isRequired
};

export default observer(inject('getPiToken')(DynamicAIStudyTestComponent));
